export default __webpack_public_path__ + "static/media/flag.0f2053ce.svg";